import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchGroup'
})
export class SearchGroupPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(it => {
      return it.group_name.toLowerCase().includes(searchText);
    });
  }

}

  

